import { ConversionFeature } from "@redotech/redo-conversion-settings-common/checkout-optimization-settings";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { JSXElementConstructor, memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

/**
 * Conversion secondary nav row that honors feature locks: hide under $3k,
 * lock-icon + schedule-demo when locked at/above $3k, otherwise link.
 */
export const LockableSecondaryNavItem = memo(function LockableSecondaryNavItem({
  feature,
  buttonLocation,
  FilledIcon,
  UnfilledIcon,
  friendlyName,
  id,
  href,
  selected,
  extraShouldHide = false,
}: {
  feature: ConversionFeature;
  buttonLocation: ScheduleDemoButtonLocation;
  FilledIcon: JSXElementConstructor<any>;
  UnfilledIcon: JSXElementConstructor<any>;
  friendlyName: string;
  id: string;
  href: string;
  /** When unlocked, optional selected override (e.g. prefix match). Locked rows force unselected. */
  selected?: boolean;
  /** Additional hide condition (e.g. Shopify Plus availability). */
  extraShouldHide?: boolean;
}) {
  const { locked, shouldHide, onLockedClick } = useConversionLockedAction(
    buttonLocation,
    feature,
  );

  // Prefer `hidden` over returning null so the row still registers in the
  // secondary-nav tree (command palette / global search).
  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : { type: "link", href }
      }
      dimmed={locked}
      FilledIcon={FilledIcon}
      friendlyName={friendlyName}
      hidden={shouldHide || extraShouldHide}
      id={id}
      isPrivate={locked}
      selected={locked ? false : selected}
      UnfilledIcon={UnfilledIcon}
    />
  );
});
